module.exports = __webpack_public_path__ + "fonts/socicon.944f06f.woff";